import { Component, Vue, Prop } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import { ProductVariant } from '@/models/ProductVariant';
import ErrorHandler from '@/support/ErrorHandler';
import { cloneDeep } from 'lodash';
import { approvedOption } from './Variants';

@Component<EditDialog>({})
export default class EditDialog extends Vue {
  @Prop({default: null})
  protected product!: ProductVariant;

  protected newProduct: ProductVariant = new ProductVariant();
  protected isLoading: boolean = true;
  protected valid: boolean = false;

  protected approvedOptions: approvedOption[] = [{
    label: 'Ok',
    value: true,
  }, {
    label: 'Niet ok',
    value: false,
  }];

  mounted() {
    if(this.product) {
      this.newProduct = cloneDeep(this.product);
    }
  }

  private getTranslation(key: string) {
    return this.$t(key);
  }


  protected close() {
    this.$emit('input', false);
    this.clear();
  }

  protected update() {
    this.isLoading = true;
    if(!this.newProduct) {
      return;
    }

    const payload = {
      comment: this.newProduct.comment,
      is_approved: this.newProduct.is_approved,
    }

    this.newProduct
      .update(payload)
      .then((product: ProductVariant) => {
        this.isLoading = false;
        this.$emit('productUpdated');
        this.close();
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected get canSaveLocation() {
    return true;
    // return this.hasName;
  }

  protected clear() {
    this.newProduct = new ProductVariant();
  }

  protected get productName() {
    return this.newProduct ? this.newProduct.product_name : '';
  }
}
